import React from 'react';
import { useClientStatementsContext } from '../context/ClientStatementsContext';
import GlobalNotification from './GlobalNotification';
import { useClientContext } from 'context/ClientContext';

const QueryStatusNotification: React.FC = () => {
  const { userCanDoQueries } = useClientStatementsContext();
  const { anyPublish } = useClientContext();

  return (
    <GlobalNotification
      show={false}
      message="Data queries are currently unavailable due to backend subscription issues. Please try again later."
    />
  );
};

export default QueryStatusNotification;
